// Import model
import { EmailField } from '../models/EmailField';

// Import base class serializer
import { FieldSerializer } from './FieldSerializer';

// Import dependency types (models and enums used in properties)
import { FieldOptions } from '../models/FieldOptions';

// Import dependency serializers (for complex types)
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for EmailField - handles JSON serialization and deserialization with type validation
 */
export class EmailFieldSerializer {
  /**
   * Deserializes a JSON string into a EmailField instance
   */
  static deserialize(json: string): EmailField {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a EmailField instance
   */
  static fromObject(obj: any): EmailField {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to EmailField');
    }


    const instance: EmailField = {
      t: obj['_t'] as string,
      description: obj['Description'] as string | undefined,
      apiName: obj['ApiName'] as string | undefined,
      defaultValue: obj['DefaultValue'] as any | undefined,
      isRequired: obj['IsRequired'] as boolean | undefined,
      options: obj['Options'] ? FieldOptionsSerializer.fromObject(obj['Options']) : undefined as any,
      name: obj['Name'] as string,
      label: obj['Label'] as string | undefined,
      enable: obj['Enable'] ? (obj['Enable'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      visible: obj['Visible'] ? (obj['Visible'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      _9Ff13Cba: obj['_9ff13cba'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of EmailField instances
   */
  static deserializeArray(json: string): EmailField[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a EmailField instance to a JSON string
   */
  static serialize(instance: EmailField): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a EmailField instance to a plain object
   */
  static toObject(instance: EmailField): any {
    return {
      '_t': instance.t,
      'Description': instance.description,
      'ApiName': instance.apiName,
      'DefaultValue': instance.defaultValue,
      'IsRequired': instance.isRequired,
      'Options': instance.options ? FieldOptionsSerializer.toObject(instance.options) : undefined,
      'Name': instance.name,
      'Label': instance.label,
      'Enable': instance.enable?.map((item: any) =>
        item
      ),
      'Visible': instance.visible?.map((item: any) =>
        item
      ),
      '_9ff13cba': instance._9Ff13Cba,
    };
  }

  /**
   * Serializes an array of EmailField instances to a JSON string
   */
  static serializeArray(instances: EmailField[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
